export default __webpack_public_path__ + "static/media/slider-war.548ef123.png";